import { useEffect, useState } from "react";

export function useKonvaImage(url) {
  const [image, setImage] = useState(null);
  useEffect(() => {
    if (!url) {
      setImage(null);
      return;
    }
    const img = new window.Image();
    img.crossOrigin = "anonymous";
    img.src = url;
    img.onload = () => setImage(img);
    return () => setImage(null);
  }, [url]);
  return image;
}
